import { Font } from "@react-pdf/renderer";
import { lightTheme } from "../../../../assetsConfig";
import { disableWordHyphenation } from "./physicalComponentPdfUtils";
let registered = false;

// react-pdf needs direct font file URLs (from fonts.gstatic.com), not the CSS
// stylesheet URL used by the web app via fontBrand / fontHeading.
const volkhovFontSrc = [
	{
		src: "https://fonts.gstatic.com/s/volkhov/v18/SlGQmQieoJcKemNeQTI.ttf",
		fontWeight: 400,
	},
	{
		src: "https://fonts.gstatic.com/s/volkhov/v18/SlGSmQieoJcKemNecTAEgA.ttf",
		fontWeight: 400,
		fontStyle: "italic" as const,
	},
	{
		src: "https://fonts.gstatic.com/s/volkhov/v18/SlGVmQieoJcKemNeeY4hoHQ.ttf",
		fontWeight: 700,
	},
	{
		src: "https://fonts.gstatic.com/s/volkhov/v18/SlGXmQieoJcKemNecTA8PHFSaA.ttf",
		fontWeight: 700,
		fontStyle: "italic" as const,
	},
];

const karlaFontSrc = [
	{
		src: "https://fonts.gstatic.com/s/karla/v33/qkBIXvYC6trAT55ZBi1ueQVIjQTD-JqqFA.ttf",
		fontWeight: 400,
	},
	{
		src: "https://fonts.gstatic.com/s/karla/v33/qkBKXvYC6trAT7RQNNK2EG7SIwPWMNlCV0lP.ttf",
		fontWeight: 400,
		fontStyle: "italic" as const,
	},
	{
		src: "https://fonts.gstatic.com/s/karla/v33/qkBIXvYC6trAT55ZBi1ueQVIjQTDJp2qFA.ttf",
		fontWeight: 600,
	},
	{
		src: "https://fonts.gstatic.com/s/karla/v33/qkBIXvYC6trAT55ZBi1ueQVIjQTDH52qFA.ttf",
		fontWeight: 700,
	},
];

export function registerPhysicalPdfFonts() {
	if (registered) {
		return;
	}

	Font.register({
		family: lightTheme.fontBrand.fontFamily,
		fonts: volkhovFontSrc,
	});

	Font.register({
		family: lightTheme.fontHeading.fontFamily,
		fonts: karlaFontSrc,
	});

	Font.registerHyphenationCallback(disableWordHyphenation);

	registered = true;
}
